import React from "react";
import { PhotoHero } from "./PhotoHero";
import { COLORS } from "../theme";

// Foto real: operador escaneando el QR en la bodega con filas de autos.
export const SBodega: React.FC = () => (
  <PhotoHero
    src="footage/escaneo-bodega.png"
    kicker="En bodega"
    kickerColor={COLORS.purpleLight}
    title="Toda la flota, ordenada y localizada"
    origin="55% 52%"
  />
);
